import httpService from "@/services/http.service";
import { ref, computed } from "vue";

const savedAssets = ref<any[]>([]);

export const useSavedAssets = () => {
  const getSavedAssets = async (id: any = null) => {
    return new Promise((resolve, reject) => {
      let filterType = "all";
      httpService.getSavedAssets(filterType).then((response) => {
        if (response.data.isSuccess) {
          savedAssets.value = [...response.data.data];
          resolve(savedAssets.value);
        }
      });
    });
  };

  const savedPosts = computed(() => {
    return savedAssets.value.filter((x) => x.assetType == "post");
  });

  const checkSavedPost = (id: string) => {
    return savedPosts.value.findIndex((x) => x.assetId == id) != -1;
  };

  const savedInfluencers = computed(() => {
    return savedAssets.value.filter((x) => x.assetType == "influencer");
  });

  const checkSavedInfluencers = (id: string) => {
    var isSaved =
      savedInfluencers.value.findIndex((x) => x.assetId == id) != -1;
    return isSaved;
  };

  const savedStocks = computed(() => {
    return savedAssets.value.filter((x) => x.assetType == "stock");
  });

  const checkSavedStocks = (id: string) => {
    return savedStocks.value.findIndex((x) => x.assetId == id) != -1;
  };

  return {
    savedStocks,
    checkSavedStocks,
    getSavedAssets,
    savedPosts,
    checkSavedPost,
    savedInfluencers,
    checkSavedInfluencers,
  };
};
